import { API_BASE_URL } from "./apiConfig";
import { logApiContext } from "../config/apiBaseUrl";

const API_URL = `${API_BASE_URL}/api/notifications`;
const logRequest = (action, url, extra = {}) =>
  logApiContext(`notificationService:${action}`, { url, API_URL, ...extra });

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const handleResponse = async (response, fallbackMessage) => {
  if (!response.ok) {
    const text = await response.text();
    console.error("[notificationService] error", {
      status: response.status,
      statusText: response.statusText,
      body: text,
    });
    throw new Error(text || fallbackMessage);
  }
  return response.json();
};

export const getNotifications = async (params = {}) => {
  const search = new URLSearchParams();
  if (params.limit !== undefined) search.append("limit", params.limit);
  if (params.startDate) search.append("startDate", params.startDate);
  if (params.endDate) search.append("endDate", params.endDate);
  if (params.unreadOnly) search.append("unread", "true");

  const query = search.toString();
  const url = `${API_URL}${query ? `?${query}` : ""}`;
  logRequest("getNotifications", url, params);
  const response = await fetch(url, { headers: authHeaders() });
  return handleResponse(response, "No se pudieron cargar las notificaciones");
};

export const markNotificationAsRead = async (id) => {
  const url = `${API_URL}/${id}/read`;
  logRequest("markNotificationAsRead", url, { id });
  const response = await fetch(url, { method: "POST", headers: authHeaders() });
  return handleResponse(response, "No se pudo marcar la notificación");
};

export const markAllNotificationsAsRead = async () => {
  const url = `${API_URL}/read-all`;
  logRequest("markAllNotificationsAsRead", url);
  const response = await fetch(url, { method: "POST", headers: authHeaders() });
  return handleResponse(response, "No se pudieron marcar las notificaciones");
};
